import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { ModalProvider } from "./components/Modal/useModal";
import setupNewRelic from "./Analytics/NewRelic";
import setupABTasty from "../src/Analytics/ABTasty";

ReactDOM.render(
    <BrowserRouter basename={"/tutors"}>
        <ModalProvider>
            <App />
        </ModalProvider>
    </BrowserRouter>,
    document.getElementById("root")
);

// Adds NewRelic script tag to head. Using the raw script in index.html causes test failures.
setupNewRelic();
setupABTasty();
